import { z } from "zod";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventStagedFailedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.StagedFailed),
});

export type AuditEventStagedFailed = z.infer<typeof auditEventStagedFailedSchema>;
